import { useLegislativeContext } from '@/lib/LegislativeContext';

export function useAvailableStates() {
  const { availableStates } = useLegislativeContext();
  return availableStates;
}
